// Lightweight conversion tracker. Fires events to whichever analytics
// providers are loaded on the page (Meta Pixel via window.fbq, PostHog
// via window.posthog, Google via window.gtag / dataLayer).

const STANDARD_PIXEL_EVENTS = new Set([
  "PageView",
  "ViewContent",
  "AddToCart",
  "InitiateCheckout",
  "Purchase",
  "Lead",
  "CompleteRegistration",
  "Search",
  "Contact",
  "Subscribe",
]);

export function trackEvent(name, payload = {}) {
  const data = { timestamp: new Date().toISOString(), ...payload };
  try {
    if (typeof window === "undefined") return;
    // Meta Pixel
    if (typeof window.fbq === "function") {
      if (STANDARD_PIXEL_EVENTS.has(name)) {
        window.fbq("track", name, data);
      } else {
        window.fbq("trackCustom", name, data);
      }
    }
    // PostHog
    if (window.posthog && typeof window.posthog.capture === "function") {
      window.posthog.capture(name, data);
    }
    // GA4 / Google Tag
    if (typeof window.gtag === "function") {
      window.gtag("event", name, data);
    }
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: name, ...data });
    }
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.info("[track]", name, data);
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn("track error", e);
  }
}

// Back-compat alias used by older WhatsApp click code
export function trackWhatsAppClick(payload = {}) {
  trackEvent("WhatsAppClick", payload);
  // Also a Lead event for Pixel optimization
  trackEvent("Lead", {
    content_name: payload.color,
    value: payload.total,
    currency: "EUR",
  });
}
